import events from 'events/';
import { Type } from "../protocol/Type.mjs";
import { createMessage } from "./createMessage.mjs";
import { getEnvironment } from "./getEnvironment.mjs";
import { observable } from "./observable.mjs";
export class Stream {
  constructor(logger, driver) {
    this.logger = logger;
    this.driver = driver;
    this._eventEmitter = new events.EventEmitter();
  }

  on(eventName, listener) {
    if (getEnvironment() !== 'Web' && !this._dispose) {
      this._dispose = observable(this.driver).postMessage(createMessage({
        type: Type.ReqStreamSubscribe
      })).on(message => this.onMessage(message));
    }

    const emitter = this._eventEmitter.on(eventName, listener);

    return function dispose() {
      emitter.off(eventName, listener);
    };
  }

  emit(eventName, data) {
    const stream = {
      eventName
    };

    if (data) {
      stream.data = JSON.stringify(data);
    }

    switch (getEnvironment()) {
      case 'Web':
        {
          return this.onMessage(createMessage({
            type: Type.ResStreamEvent,
            payload: {
              stream
            }
          }));
        }

      default:
        {
          this.driver.postMessage(createMessage({
            type: Type.ReqStreamEmit,
            payload: {
              stream
            }
          }));
        }
    }
  }

  onMessage(message) {
    var _message$payload, _message$payload$stre;

    if ('error' in message) {
      throw new Error(message.error);
    }

    if (!((_message$payload = message.payload) !== null && _message$payload !== void 0 && (_message$payload$stre = _message$payload.stream) !== null && _message$payload$stre !== void 0 && _message$payload$stre.eventName)) {
      return this.logger.log('ERROR', 'bridge.stream.onMessage', '이벤트 이름을 찾을 수 없어요');
    }

    const {
      eventName
    } = message.payload.stream;

    if (message.payload.stream.data) {
      this._eventEmitter.emit(eventName, JSON.parse(message.payload.stream.data));
    } else {
      this._eventEmitter.emit(eventName, undefined);
    }
  }

}